import type { SideNavV2Item, SideNavV2Section } from "@/components/interactive/SideNavV2";

/** The rail category behind the workspace mark: the global settings pages. */
export const GLOBAL_NAV_CATEGORY_ID = "global-settings";
const GLOBAL_NAV_ADMIN_ITEM_ID = "team-admin-links";

/**
 * The global settings sidebar as a rail category. Its pages span every project and environment,
 * so it lists only team-level destinations, with the admin links last as a parent, which the
 * category sidebar lays out as its own titled group.
 */
export const buildGlobalNavCategory = ({
  inlineItems,
  adminItems,
}: {
  inlineItems: readonly SideNavV2Item<string>[];
  adminItems: readonly SideNavV2Item<string>[];
}): SideNavV2Section<string> => ({
  id: GLOBAL_NAV_CATEGORY_ID,
  label: "Global settings",
  items: [
    ...inlineItems,
    ...(adminItems.length === 0
      ? []
      : [
          {
            id: GLOBAL_NAV_ADMIN_ITEM_ID,
            label: "Admin",
            icon: "lock" as const,
            admin: true,
            children: adminItems,
          },
        ]),
  ],
});
